function trackHeights(){
    const tracking = document.querySelectorAll('[data-track-height]');

    tracking.forEach((elm) => {
        const label = elm.dataset.trackHeight;

        let elmHeight = elm.offsetHeight;
        document.documentElement.style.setProperty('--' + label + '-height', elmHeight + 'px');
    });
}
export { trackHeights };
